<template>
  <v-dialog v-model="dialog" max-width="1000px" transition="dialog-bottom-transition" persistent content-class="buscar-doc-dialog">
    <v-card class="overflow-hidden" style="border-radius:4px">
      <!-- HEADER -->
      <v-toolbar flat height="56" color="#37474f" dark class="flex-shrink-0">
        <v-icon class="mr-2">mdi-file-search-outline</v-icon>
        <v-toolbar-title class="font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.9rem;">Seleccionar Documento de Referencia</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-tabs
          v-model="tab"
          background-color="#37474f"
          color="white"
          dark
          grow
          height="48"
        >
          <v-tab href="#facturas" class="font-weight-bold text-uppercase" style="font-size:0.75rem;letter-spacing:0.8px">
            <v-icon left small>mdi-file-document-outline</v-icon>
            Facturas Electrónicas
          </v-tab>
          <v-tab href="#tiquetes" class="font-weight-bold text-uppercase" style="font-size:0.75rem;letter-spacing:0.8px">
            <v-icon left small>mdi-ticket-percent-outline</v-icon>
            Tiquetes Electrónicos
          </v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <v-tabs-items v-model="tab" class="bg-light">
          <!-- PANEL FACTURAS -->
          <v-tab-item value="facturas">
            <div class="pa-3">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Buscar por código, cliente o clave..."
                outlined dense hide-details
                class="mb-3"
              ></v-text-field>

              <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                class="modern-table rounded-xl elevation-1 border-light"
                :items-per-page="5"
                @click:row="selected"
              >
                <template v-slot:[`item.totalComprobante`]="{ item }">
                  <span class="font-weight-bold">
                    {{ item.moneda === 'CRC' ? '₡' : '$' }}{{ item.totalComprobante.toLocaleString('es-CR', { minimumFractionDigits: 2 }) }}
                  </span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn color="blue-grey darken-2" depressed dark small style="border-radius:4px" @click.stop="selected(item)">
                    <v-icon left size="14">mdi-check</v-icon> Seleccionar
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </v-tab-item>

          <!-- PANEL TIQUETES -->
          <v-tab-item value="tiquetes">
            <div class="pa-3">
              <v-text-field
                v-model="search2"
                prepend-inner-icon="mdi-magnify"
                label="Buscar tiquete..."
                outlined dense hide-details
                class="mb-3"
              ></v-text-field>

              <v-data-table
                :headers="headers2"
                :items="items2"
                :search="search2"
                class="modern-table rounded-xl elevation-1 border-light"
                :items-per-page="5"
                @click:row="selected2"
              >
                <template v-slot:[`item.totalComprobante`]="{ item }">
                  <span class="font-weight-bold">
                    {{ item.moneda === 'CRC' ? '₡' : '$' }}{{ item.totalComprobante.toLocaleString('es-CR', { minimumFractionDigits: 2 }) }}
                  </span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn color="blue-grey darken-2" depressed dark small style="border-radius:4px" @click.stop="selected2(item)">
                    <v-icon left size="14">mdi-check</v-icon> Seleccionar
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="pa-3" style="background:#f8fafc;border-top:1px solid rgba(0,0,0,0.08)">
        <v-spacer></v-spacer>
        <v-btn text class="font-weight-bold" style="border-radius:4px" @click="close">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tab: 'facturas',
      search: "",
      search2: "",
      headers: [
        { text: "Código", value: "codigoFact" },
        { text: "Cliente", value: "clienteNombre" },
        { text: "Fecha", value: "fechaString" },
        { text: "Monto Total", value: "totalComprobante", align: 'end' },
        { text: "Acciones", value: "actions", sortable: false, align: 'end' },
      ],
      headers2: [
        { text: "Tiquete #", value: "codigoFact" },
        { text: "Cliente", value: "clienteNombre" },
        { text: "Fecha", value: "fechaString" },
        { text: "Monto Total", value: "totalComprobante", align: 'end' },
        { text: "Acciones", value: "actions", sortable: false, align: 'end' },
      ],
      items: [],
      items2: [],
    };
  },
  computed: {
    ...mapGetters(["strCia"]),
  },
  created() {
    this.getData();
    this.getData2();
  },
  watch: {
    dialog(val) {
      if (val) {
        this.tab = 'facturas';
        this.search = "";
        this.search2 = "";
        this.items = [];
        this.items2 = [];
        this.getData();
        this.getData2();
      }
    },
  },
  methods: {
    getData() {
      let me = this;
      axios.get(`api/Facturacion/getComprobantesFacturasNC?cia=${this.strCia}&docNombre=Facturas&tipoDoc=01`)
        .then(res => me.items = res.data)
        .catch(err => console.log(err));
    },
    getData2() {
      let me = this;
      axios.get(`api/Facturacion/getComprobantesFacturasNC?cia=${this.strCia}&docNombre=Tiquetes&tipoDoc=04`)
        .then(res => me.items2 = res.data)
        .catch(err => console.log(err));
    },
    selected(item) {
      const editedItem = Object.assign({}, item);
      editedItem.documentoOrigen = "Factura Electrónica";
      editedItem.codigoDev = item.clavehacienda;
      editedItem.clavehacienda = "";
      editedItem.nombreTabla = "NotasCredito";
      editedItem.NombreTablaReferencia = "Facturas";
      this.$emit("seleccionar", editedItem);
    },
    selected2(item) {
      const editedItem = Object.assign({}, item);
      editedItem.documentoOrigen = "Tiquete Electrónico";
      editedItem.codigoDev = item.clavehacienda;
      editedItem.clavehacienda = "";
      editedItem.nombreTabla = "NotasCredito";
      editedItem.NombreTablaReferencia = "Tiquetes";
      this.$emit("seleccionar", editedItem);
    },
    close() {
      this.$emit("cerrar");
    },
  },
};
</script>

<style scoped>
.modern-table {
  border: 1px solid rgba(0,0,0,0.05) !important;
}
.modern-table >>> thead th {
  background-color: #eceff1 !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  letter-spacing: 0.07em;
  color: #546e7a !important;
  border-bottom: none !important;
}
.modern-table >>> tbody tr:hover {
  background-color: #f1f5f9 !important;
}
</style>

